// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__2II+y","inputSearch":"Search_inputSearch__zAovB"};